import Address from "./address";
import { ValidateIf, Length, Validate, ValidateNested } from "class-validator";
import { IsPESEL } from "./validator/pesel-validator";
import { IsREGON } from "./validator/regon-validator";

class Insured {
  insuredSameAsInsurer: boolean =  true;
  type: number = 1;

  @ValidateIf(o => o.type === 1)
  @Length(1, 50)
  firstName: string = '';

  @ValidateIf(o => o.type === 1)
  @Length(1, 50)
  lastName: string = '';

  @ValidateIf(o => o.type === 2)
  @Length(1, 100)
  companyName: string = '';

  @ValidateIf(o => o.type === 1)
  @Validate(IsPESEL)
  PESEL: string = '';

  @ValidateIf(o => o.type === 2)
  @Validate(IsREGON)
  REGON: string = '';

  @ValidateNested()
  address: Address;

  constructor() {
    this.address = new Address();
  }
}

export default Insured;
